"use client";

import { c as _c } from "react/compiler-runtime";
import { useNextMintDrop } from "@/hooks/useNextMintDrop";
import { useNowMintingStatus } from "@/hooks/useNowMintingStatus";
import { shouldShowNextMintInLatestDrop } from "@/helpers/mint-visibility.helpers";
import LatestDropNextMintSection from "./LatestDropNextMintSection";
import NowMintingSection from "./NowMintingSection";
export default function LatestDropSection() {
  const $ = _c(6);
  const {
    nft,
    isFetching,
    isDropComplete,
    isStatusLoading
  } = useNowMintingStatus();
  const {
    nextMint,
    waveId,
    isFetching: isNextMintFetching,
    isSettingsLoaded
  } = useNextMintDrop();
  const isNextMintReady = isSettingsLoaded && (!waveId || !isNextMintFetching);
  const isDecisionReady = !isFetching && !isStatusLoading && isNextMintReady;
  if (!isDecisionReady) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <NowMintingSection nft={undefined} isFetching={true} />;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  const shouldShowNextMint = shouldShowNextMintInLatestDrop({
    isMintEnded: isDropComplete,
    nextMintExists: !!nextMint
  });
  if (shouldShowNextMint && nextMint) {
    let t0;
    if ($[1] !== nextMint) {
      t0 = <LatestDropNextMintSection drop={nextMint} />;
      $[1] = nextMint;
      $[2] = t0;
    } else {
      t0 = $[2];
    }
    return t0;
  }
  let t0;
  if ($[3] !== isFetching || $[4] !== nft) {
    t0 = <NowMintingSection nft={nft} isFetching={isFetching} />;
    $[3] = isFetching;
    $[4] = nft;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  return t0;
}